// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo_logoContainer_tyJd_","logo":"logo_logo_tGJG7","xs":"logo_xs_ZYIAu","s":"logo_s_ujwWB","m":"logo_m_wXO8m","l":"logo_l_O_czD","logoText":"logo_logoText_jtY6P"};